import { EventTypes } from 'redux-segment';

import * as api from 'Shared/api';
import { handleSuccess, handleError, showNotificationError } from 'Shared/helpers';

export const readNotification = id => async dispatch => {
  try {
    const response = await api.readNotification(id);
    if (response.data.web_notification)
      dispatch({
        type: 'NOTIFICATION_READ_RESPONSE',
        payload: response.data.web_notification,
      });
  } catch (error) {
    showNotificationError(error);
  }
};

export const readNotifications = () => (dispatch, getState) => {
  const state = getState();

  return api.readNotifications().then(
    response => {
      const json = response.data;

      dispatch({
        type: 'NOTIFICATIONS_READ_RESPONSE',
        payload: {
          web_notifications: json.web_notifications,
        },
        meta: {
          analytics: {
            eventType: EventTypes.track,
            eventPayload: {
              event: 'Opened Notifications',
              properties: { app_id: state.app.id },
            },
          },
        },
      });
    },
    error => {
      dispatch(handleError(error));
    }
  );
};

export const updateWorkspaceNotificationCard = (id, params) => dispatch =>
  api.updateWorkspaceNotificationCard(id, params).then(
    response => {
      dispatch({
        type: 'WORKSPACE_NOTIFICATION_CARD_PUT_RESPONSE',
        payload: response.data,
      });
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const getWorkspaceNotificationCards = () => dispatch =>
  api.getWorkspaceNotificationCards().then(
    response => {
      dispatch({
        type: 'WORKSPACE_NOTIFICATION_CARDS_GET_RESPONSE',
        payload: response.data,
      });
      return response;
    },
    error => {
      dispatch(handleError(error));
    }
  );

export const getNotifications = () => dispatch =>
  api.getNotifications().then(response => {
    dispatch({
      type: 'NOTIFICATIONS_GET_RESPONSE',
      payload: {
        web_notifications: response.data.web_notifications,
      },
    });
  });

export const getNotificationDestinations = () => dispatch =>
  api.getNotificationDestinations().then(response => {
    dispatch({
      type: 'NOTIFICATION_DESTINATIONS_GET_RESPONSE',
      payload: {
        notification_destinations: response.data.notification_destinations,
      },
    });
    return response;
  });

export const enableNotificationDestination = ({ notification_slug }) => dispatch =>
  api.enableNotificationDestination({ notification_slug }).then(response => {
    dispatch({
      type: 'NOTIFICATION_DESTINATION_ENABLE_RESPONSE_SUCCESS',
      payload: {
        notification_destinations: response.data.notification_destinations,
      },
    });
    return response;
  });

export const disableNotificationDestination = ({ notification_slug }) => dispatch =>
  api.disableNotificationDestination({ notification_slug }).then(response => {
    dispatch({
      type: 'NOTIFICATION_DESTINATION_DISABLE_RESPONSE_SUCCESS',
      payload: {
        notification_destinations: response.data.notification_destinations,
      },
    });
    return response;
  });

export const updateNotificationDestinationSettings = ({ notificationDestinationID, settings }) => dispatch => {
  dispatch({
    type: 'UPDATE_NOTIFICATION_DESTINATION_SETTINGS_REQUEST',
    payload: { notificationDestinationID, settings },
  });
  api.updateNotificationDestinationSettings({ notificationDestinationID, settings }).then(
    response => {
      handleSuccess(response);
    },
    error => {
      handleError(error);
    }
  );
};

export const disconnectNotification = notificationDestinationID => () =>
  api.disconnectNotification({ notificationDestinationID }).then(
    response => {
      handleSuccess(response);
    },
    error => {
      handleError(error);
    }
  );

export const disconnectOrganizationNotificationDestination = notificationDestinationID => () =>
  api.disconnectOrganizationNotificationDestination({ notificationDestinationID }).then(
    response => {
      handleSuccess(response);
    },
    error => {
      handleError(error);
    }
  );

export const toggleNotification = notificationDestinationID => () =>
  api.toggleNotification({ notificationDestinationID }).then(
    response => {
      handleSuccess(response);
    },
    error => {
      handleError(error);
    }
  );
